// Set by TranslationResilience, read by ReactErrorBoundary to skip its remount-recovery while the
// library is on, keeping the two mitigations mutually exclusive during the flag A/B.
let active = false

export const setTranslationResilienceActive = (value: boolean): void => {
  active = value
}

export const isTranslationResilienceActive = (): boolean => active
